import axios from "axios"
import library from "../../../utils/Library"

export const getAllUserGrantedAppRoleEAuthz = async (
  applicationInstanceId,
  appCode = "ME",
  userId = null,
) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("e_authz") +
    `/getAllUserGrantedAppRoleEAuthz?applicationInstanceId=${applicationInstanceId}&appCode=${appCode}${
      userId ? `&userId=${userId}` : ""
    }`

  return await axios({
    url: URL,
    method: "GET",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
